export default "__VITE_ASSET__C_J7zfvb__"